import { Navigate, useMatch } from "react-router";
import * as ROUTES from "../../../../constants/routes";
import { ReactNode } from "react";

export const EmptySupplierQueryParamBoundary = ({
  children,
}: {
  children: ReactNode;
}) => {
  const supplierId = useMatch({
    path: ROUTES.SUPPLIER.pattern,
    end: false,
  })?.params.supplierIdOrUrlId;

  if (!supplierId) {
    return <Navigate to={ROUTES.SUPPLIERS} />;
  }

  return children;
};
